import { render, staticRenderFns } from "./NoteFormView.vue?vue&type=template&id=1d8cc71f&scoped=true&"
import script from "./NoteFormView.vue?vue&type=script&lang=js&"
export * from "./NoteFormView.vue?vue&type=script&lang=js&"
import style0 from "./NoteFormView.vue?vue&type=style&index=0&id=1d8cc71f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8cc71f",
  null
  
)

export default component.exports